import "./App.css";
import AdminUi from "./Components/LandingPage/LandingPage";

function App() {
  return (
    <div className="App">
      <AdminUi />
    </div>
  );
}

export default App;
